/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_ItemInputs */

const th_new_item = /** @type {(inputs: New_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ สร้างใหม่`)
};

const en_new_item = /** @type {(inputs: New_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ New`)
};

const ja_new_item = /** @type {(inputs: New_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ 新規`)
};

const zh_new_item = /** @type {(inputs: New_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ 新建`)
};

const es_new_item = /** @type {(inputs: New_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Nuevo`)
};

const pt_new_item = /** @type {(inputs: New_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Novo`)
};

const id_new_item = /** @type {(inputs: New_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Baru`)
};

const fr_new_item = /** @type {(inputs: New_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Nouveau`)
};

const tl_new_item = /** @type {(inputs: New_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Bago`)
};

const vi_new_item = /** @type {(inputs: New_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Mới`)
};

const ko_new_item = /** @type {(inputs: New_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ 새로 만들기`)
};

const de_new_item = /** @type {(inputs: New_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Neu`)
};

const ru_new_item = /** @type {(inputs: New_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Создать`)
};

const tr_new_item = /** @type {(inputs: New_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Yeni`)
};

const it_new_item = /** @type {(inputs: New_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Nuovo`)
};

const pl_new_item = /** @type {(inputs: New_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Nowe`)
};

const uk_new_item = /** @type {(inputs: New_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Створити`)
};

const hi_new_item = /** @type {(inputs: New_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ नया`)
};

const ar_new_item = /** @type {(inputs: New_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ جديد`)
};

const ms_new_item = /** @type {(inputs: New_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Baharu`)
};

const bn_new_item = /** @type {(inputs: New_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ নতুন`)
};

const zh_tw2_new_item = /** @type {(inputs: New_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ 新增`)
};

const zh_hk2_new_item = /** @type {(inputs: New_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ 新增`)
};

const ur_new_item = /** @type {(inputs: New_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ نیا`)
};

const fa_new_item = /** @type {(inputs: New_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ تازه`)
};

const sw_new_item = /** @type {(inputs: New_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Mpya`)
};

const nl_new_item = /** @type {(inputs: New_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Nieuw`)
};

/**
* | output |
* | --- |
* | "+ New" |
*
* @param {New_ItemInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const new_item = /** @type {((inputs?: New_ItemInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_ItemInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_new_item(inputs)
	if (locale === "ja") return ja_new_item(inputs)
	if (locale === "zh") return zh_new_item(inputs)
	if (locale === "es") return es_new_item(inputs)
	if (locale === "pt") return pt_new_item(inputs)
	if (locale === "id") return id_new_item(inputs)
	if (locale === "fr") return fr_new_item(inputs)
	if (locale === "tl") return tl_new_item(inputs)
	if (locale === "vi") return vi_new_item(inputs)
	if (locale === "ko") return ko_new_item(inputs)
	if (locale === "de") return de_new_item(inputs)
	if (locale === "ru") return ru_new_item(inputs)
	if (locale === "tr") return tr_new_item(inputs)
	if (locale === "it") return it_new_item(inputs)
	if (locale === "pl") return pl_new_item(inputs)
	if (locale === "uk") return uk_new_item(inputs)
	if (locale === "hi") return hi_new_item(inputs)
	if (locale === "ar") return ar_new_item(inputs)
	if (locale === "ms") return ms_new_item(inputs)
	if (locale === "bn") return bn_new_item(inputs)
	if (locale === "zh-TW") return zh_tw2_new_item(inputs)
	if (locale === "zh-HK") return zh_hk2_new_item(inputs)
	if (locale === "ur") return ur_new_item(inputs)
	if (locale === "fa") return fa_new_item(inputs)
	if (locale === "sw") return sw_new_item(inputs)
	if (locale === "nl") return nl_new_item(inputs)
	return en_new_item(inputs)
});